import { useGetCommonStore } from '@/store';
import { LOYALTY_TO_VIP_MAP } from '../constants';

const VIP_LEVEL_MIN = 8;
const VIP_LEVEL_MAX = 12;

export const useVIP = () => {
  const useCommonStore = useGetCommonStore();
  const loyaltySseState = useCommonStore.use.loyaltySseState();
  const loyaltySseIsLoading = useCommonStore.use.loyaltySseIsLoading();

  const level = loyaltySseState?.level?.number ?? null;
  const isVip =
    level !== null && level >= VIP_LEVEL_MIN && level <= VIP_LEVEL_MAX;
  const vipLevel = level ? (LOYALTY_TO_VIP_MAP[level] ?? null) : null;

  return { isVip, level: vipLevel, isLoading: loyaltySseIsLoading };
};
